import React from "react";


const SpecialistProfile = () => {
  return (
    <section className="specialist-profile" id="team">
      <h2 className="specialist-heading">Program Specialist Profile</h2>
      <p className="specialist-description">
        <strong>Imran Ahmed</strong><br />
        BS Engineering | ACII | MBA (Finance)<br />
        Course Instructor – CMT Level I Preparation
      </p>
      <p className="specialist-text">
        Imran Ahmed is a seasoned finance professional currently serving in a C-suite 
        leadership role, at a leading corporate organization. With over 20 years of experience 
        in strategic management, technical analysis, insurance product development, he brings 
        unmatched depth and clarity to his teaching.
      </p>
      <p className="specialist-text">
        Imran have already cleared CMT levels bringing deep market insight and instructional clarity, 
        combined with market insight and instructional precision. His engineering background 
        and MBA in Finance enable him to simplify complex concepts through structured, 
        scenario-based learning.
      </p>
      <p className="specialist-text">
        Imran’s CMT Level I prep course is designed to help candidates master charting 
        techniques, trend analysis, and market psychology with practical, real-world relevance. 
        His approach is rigorous yet accessible—ideal for professionals seeking to build a 
        strong foundation in technical analysis and pass the CMT Level I exam with confidence.
      </p>
      
    </section>
  );
};

export default SpecialistProfile;
